import { render } from "./QueryTablePreview.vue?vue&type=template&id=b3c9407c&ts=true"
import script from "./QueryTablePreview.vue?vue&type=script&lang=ts"
export * from "./QueryTablePreview.vue?vue&type=script&lang=ts"

import "./QueryTablePreview.vue?vue&type=style&index=0&id=b3c9407c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QSpace,QBtn,QSeparator});qInstall(script, 'directives', {ClosePopup});
